<template>
    <div class="card shadow-md">
        <div class="uk-transition-toggle overflow-hidden">
            <anchor
                v-if="doc.button"
                :field="doc.button"
            >
                <asset
                    class="uk-transition-scale-up uk-transition-opaque"
                    :url="doc.image"
                    :w="imageWidth"
                    :h="imageHeight"
                    fit="crop_focal"
                />
            </anchor>
            <asset
                v-else
                :url="doc.image"
                :w="imageWidth"
                :h="imageHeight"
                fit="crop_focal"
            />
        </div>

        <div
            class="px-8 py-12 text-center"
            :class="bodyClass"
        >
            <h5
                v-if="doc.heading"
                class="strong handwritten ms-xl tracking-wide mb-3"
            >
                {{ doc.heading }}
            </h5>
            <p v-if="doc.text">
                {{ doc.text }}
            </p>
            <p v-if="doc.button">
                <anchor
                    class="btn mt-6"
                    :class="'btn-' + doc.button_style"
                    :field="doc.button"
                >
                    {{ doc.button.title }}
                </anchor>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: ["doc", "image_ratio"],

    computed: {
        imageWidth() {
            return 575;
        },
        imageHeight() {
            return this.image_ratio
                ? (this.imageWidth * this.image_ratio) / 100
                : this.imageWidth * 0.6;
        },
        bodyClass() {
            return {
                primary: "bg-primary inverse",
                secondary: "bg-secondary inverse",
                muted: "bg-muted"
            }[this.doc.background_color];
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Card.vue